import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetBuildingAmenityByIdQuery } from "../../../services/bClientApi"
import BuildingAmenityEntry from "../../../Components/BuildingAmenity/BuildingAmenityEntry/BuildingAmenityEntry"
import DataLogList from "../../../Components/DataLogs/DataLogList"

export default function BuildingAmenityPage() {
    const { buildingAmenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetBuildingAmenityByIdQuery(buildingAmenityId, { skip: !buildingAmenityId })
    const buildingAmenityData = data || {}

    return (
        <Container>
            <Row>
                <Col
                    xs={12}
                    lg={9}
                >
                    <h1>Building Amenity Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {buildingAmenityId && buildingAmenityData && buildingAmenityData._id && !isLoading && (
                        <BuildingAmenityEntry
                            buildingAmenityData={buildingAmenityData}
                            fullView={true}
                        />
                    )}
                </Col>

                <Col
                    xs={12}
                    lg={3}
                >
                    <DataLogList
                        dataType="buildingAmenity"
                        dataId={buildingAmenityId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
